import AutorenewIcon from '@mui/icons-material/Autorenew';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import type { ReactNode } from 'react';
import * as UI from '@siloreal:shared:ui';
import * as HOOKS from '@siloreal:shared:hooks';

type ComingSoonInteractionProps = {
  interactionId: string;
  label: string;
  icon: ReactNode;
  variant: 'safe' | 'danger' | 'major';
};

function ComingSoonInteraction(props: ComingSoonInteractionProps) {
  const { interactionId, label, icon, variant } = props;

  return (
    <UI.Tooltip content={label} tid={`${interactionId}-tooltip`}>
      <UI.Button
        variant={variant}
        uppercase={false}
        disabled
        ariaLabel={label}
        icon={icon}
        tid={`${interactionId}-btn`}
      />
    </UI.Tooltip>
  );
}

type InteractionProps = {
  interactionId: string;
  disabled?: boolean;
};

export function InsureInteraction({ interactionId }: InteractionProps) {
  const i18n = HOOKS.useLocale();

  return (
    <ComingSoonInteraction
      interactionId={interactionId}
      label={i18n.t('temp.private.list.silospro.insure')}
      icon={<GppGoodOutlinedIcon fontSize="small" />}
      variant="major"
    />
  );
}

export function QuoteInteraction({ interactionId }: InteractionProps) {
  const i18n = HOOKS.useLocale();

  return (
    <ComingSoonInteraction
      interactionId={interactionId}
      label={i18n.t('temp.private.list.silospro.quote')}
      icon={<AutorenewIcon fontSize="small" />}
      variant="major"
    />
  );
}
